import classNames from 'classnames';
import type { HTMLAttributes, ReactNode } from 'react';

import type { ButtonProps } from './Button';
import styles from './ButtonGroup.module.css';
import { ButtonGroupProvider } from './ButtonGroupContext';

export interface ButtonGroupProps extends HTMLAttributes<HTMLDivElement> {
  children: ReactNode;
  size?: ButtonProps['size'];
  variant?: ButtonProps['variant'];
  color?: ButtonProps['color'];
  /** Join the buttons into a single segmented control (no gap, shared edges). */
  isAttached?: boolean;
  /** Disable every button in the group. */
  disabled?: boolean;
}

export const ButtonGroup = ({
  children,
  size,
  variant,
  color,
  isAttached = false,
  disabled,
  className,
  ...rest
}: ButtonGroupProps) => (
  <ButtonGroupProvider value={{ size, variant, color, disabled }}>
    <div
      role="group"
      className={classNames(
        styles.group,
        isAttached ? styles.attached : styles.spaced,
        className
      )}
      {...rest}
    >
      {children}
    </div>
  </ButtonGroupProvider>
);
